// extracted by mini-css-extract-plugin
module.exports = {"main":"Profile_main__2ipEH","imageBanner":"Profile_imageBanner__2ATZ5"};